<template>
  <a
    v-if="external"
    :href="to"
    target="_blank"
    rel="noopener"
    :class="classes()"
    v-on:click="onLinkClick"
  >
    <Icon
      v-if="icon && iconPos === 'left'"
      :name="icon"
      color="primaryBlueLight"
      :class="`${el}__icon ${el}__icon--${iconPos}`"
    />
    <slot />
    <Icon
      v-if="icon && iconPos === 'right'"
      :name="icon"
      color="primaryBlueLight"
      :class="`${el}__icon ${el}__icon--${iconPos}`"
    />
  </a>
  <component
    :is="to ? 'router-link' : 'span'"
    v-else
    :to="to"
    :class="classes()"
    @click.native="onLinkClick()"
    @click="onLinkClick()"
    tabindex="0"
    @keyup.enter="onLinkClick()"
    @keyup.space="onLinkClick()"
  >
    <Icon
      v-if="icon && iconPos === 'left'"
      :name="icon"
      color="primaryBlueLight"
      :class="`${el}__icon ${el}__icon--${iconPos}`"
      size="m"
    />
    <slot />
    <Icon
      v-if="icon && iconPos === 'right'"
      :name="icon"
      color="primaryBlueLight"
      :class="`${el}__icon ${el}__icon--${iconPos}`"
      size="m"
    />
  </component>
</template>

<script>
import { IconNameTypes } from '@/constants/enums';
import Icon from '@/objects/Icon';
export default {
  name: 'Link',
  components: {
    Icon,
  },
  props: {
    to: String,
    size: {
      type: String,
      default: 'm',
      validator: (val) => ['s', 'm', 'l', 'xl'].includes(val),
    },
    title: String,
    external: Boolean,
    icon: {
      type: String,
      validator: (val) => IconNameTypes.includes(val),
    },
    iconPos: {
      type: String,
      default: 'left',
      validator: (val) => ['left', 'right'].includes(val),
    },
    weight: {
      type: String,
      default: 'bold',
      validator: (val) => ['regular', 'bold'].includes(val),
    },
    noUnderline: Boolean,
    onClick: Function,
  },
  data() {
    return {
      el: 'o-link',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--${this.size}`]: this.size,
          [`${el}--${this.weight}`]: this.weight,
          [`${el}__iconPos--${this.iconPos}`]: this.icon,
          [`${el}--noUnderline`]: this.noUnderline,
          [`${el}--external`]: this.external,
        };
      },
    };
  },
  methods: {
    onLinkClick(e) {
      if (this.onClick) {
        this.onClick(e);
      }
      this.$emit('click');
    },
  },
};
</script>
